'use client';

import LinkButton from '@umodeapporg/ui/components/Navigation/LinkButton';
import { MaterialSymbol } from '@umodeapporg/ui/components/UI/MaterialSymbol';
import { ReactNode } from 'react';

import { SectionTitle } from '@/components/layout/SectionTitle';
import { SURFACE_CARD } from '@/components/surface/surfaces';
import { cn } from '@/lib/utils';

/** Para onde o bloco leva, quando a resposta dele se resolve em outra tela. */
export interface IBlocoAcao {
  label: string;
  href: string;
}

interface BlocoCardProps {
  /** A PERGUNTA é o título do bloco: a tela responde cinco perguntas, não exibe cinco painéis. */
  pergunta: string;
  /** De onde vem o número, numa linha: quem lê nunca tem de adivinhar a origem. */
  fonte?: string;
  acao?: IBlocoAcao;
  className?: string;
  children: ReactNode;
}

/**
 * A moldura dos cinco blocos da Visão executiva: a pergunta como título, a origem do
 * número embaixo dela e, quando existe, o caminho para a tela que resolve a resposta.
 */
export function BlocoCard({ pergunta, fonte, acao, className, children }: BlocoCardProps) {
  return (
    <section className={cn(SURFACE_CARD, 'flex min-w-0 flex-col gap-2 p-4', className)}>
      <header className="flex flex-col gap-0.5">
        {/* A PERGUNTA em 18px: ela é o que se procura na tela, e no tamanho dos títulos de
            bloco de dentro de uma página ela desaparecia entre os números. */}
        <SectionTitle size="lg">{pergunta}</SectionTitle>
        {fonte !== undefined && <p className="text-xs text-foreground-subtle">{fonte}</p>}
      </header>

      <div className="flex min-w-0 flex-1 flex-col gap-2">{children}</div>

      {/* Preso embaixo: ao lado de um bloco mais alto este estica, e a saída fecha o
          cartão em vez de deixar a altura sobrando em branco. */}
      {acao !== undefined && (
        <LinkButton href={acao.href} variant="text" tone="brand" size="sm" className="mt-auto w-fit normal-case">
          {acao.label}
          <MaterialSymbol icon="arrow_forward" size={16} />
        </LinkButton>
      )}
    </section>
  );
}
